import type { FiltroAgenda } from '@/pages/agenda/types';

const FILTROS: { id: FiltroAgenda; rotulo: string }[] = [
  { id: 'tudo', rotulo: 'Tudo' },
  { id: 'eventos', rotulo: 'Só eventos' },
  { id: 'acampamentos', rotulo: 'Acampamentos' },
  { id: 'formacoes', rotulo: 'Formações' },
  { id: 'missas', rotulo: 'Missas' },
];

interface BarraFiltrosProps {
  ativo: FiltroAgenda;
  onMudar: (filtro: FiltroAgenda) => void;
}

export default function BarraFiltros({ ativo, onMudar }: BarraFiltrosProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1">
      {FILTROS.map((f) => {
        const selecionado = ativo === f.id;
        return (
          <button
            key={f.id}
            type="button"
            onClick={() => onMudar(f.id)}
            className={`shrink-0 cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
              selecionado
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {f.rotulo}
          </button>
        );
      })}
    </div>
  );
}